// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/noop.js
// module id = 79
// module chunks = 3